module.exports = __webpack_public_path__ + "img/ver3.c0491a37.jpg";